import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  ignoreScroll = true;
}
